import { List, ListItem } from "@mui/material";
import { Vegsperring } from "../../services/RuteplanAPI";
import { IRoutePartProps } from "./RouteDescription";
import vegsperringIconSource from "../../assets/roadblock_icon.svg"

export default function Vegsperringer (props: IRoutePartProps) {
  
    return (        
        <>
            {props.roadFeatures && props.roadFeatures.vegsperringer && props.roadFeatures.vegsperringer.length > 0 &&
            <List>
                {props.roadFeatures.vegsperringer.map( (vegsperring: Vegsperring, index: number) => (
                    <ListItem 
                    key={vegsperring.function + index} 
                    className="roadFeature" 
                    onClick={(event) => {props.onClick(vegsperring, event)}}
                    onMouseEnter={() => props.onMouseEnterItem(vegsperring)}
                        onMouseLeave={props.onMouseLeaveItem}> 
                        <img src={vegsperringIconSource} height="24" style={{paddingRight:"5px"}} alt="Vegsperring icon" title="vegsperringIcon"/> 
                        {vegsperring.function}
                    </ListItem>
                ))}
            </List>        
            }
        </>
    )
}